import React from 'react';

import GDPRContext, { GDPRContextValues } from '@smart-tv/contexts/gdpr-context/gdpr-context';

export const useGDPR = (): GDPRContextValues => {
  const values = React.useContext(GDPRContext);

  return { ...values };
};

export default useGDPR;
